/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_View_FeedbackInputs */



/**
* | output |
* | --- |
* | "View feedback" |
*
* @param {Practice_View_FeedbackInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_view_feedback = /** @type {((inputs?: Practice_View_FeedbackInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_View_FeedbackInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bekijk feedback")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir le feedback")
	return /** @type {LocalizedString} */ ("View feedback")
});